import Modal from "./Modal";

export default function ChangePasswordModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900">Change Password</h2>

        <p className="text-sm text-gray-500 mt-2">
          Update your account password.
        </p>
      </div>

      <div className="space-y-5">
        <Input label="Current Password" type="password" />

        <Input label="New Password" type="password" />

        <Input label="Confirm Password" type="password" />
      </div>

      <div className="flex justify-end gap-3 mt-8">
        <button
          onClick={onClose}
          className="
            px-5
            py-3
            rounded-2xl
            border
            border-gray-200
          "
        >
          Cancel
        </button>

        <button
          className="
            px-5
            py-3
            rounded-2xl
            bg-primary-700
            text-white
          "
        >
          Update Password
        </button>
      </div>
    </Modal>
  );
}

function Input({ label, type }) {
  return (
    <div>
      <label className="block text-sm text-gray-600 mb-2">{label}</label>

      <input
        type={type}
        className="
          w-full
          px-4
          py-3
          rounded-2xl
          border
          border-gray-200
          focus:outline-none
          focus:ring-2
          focus:ring-primary-200
        "
      />
    </div>
  );
}
